import { BenefitDTOBenefitEnum, DocumentsDTO } from 'probonio-shared-ui/api';
import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class BAVBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ documents }: { documents?: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.Bav.toLowerCase();
    return [
      { title: 'subPage.employees', to: `/benefits/${benefit}` },
      { title: 'BAV.contracts', to: `/benefits/${benefit}/contracts`, hasSubpages: true },
      { title: 'bavModule:terms.title', to: `/benefits/${benefit}/terms` },
      ...(documents?.totalCount ? [{ title: 'subPage.documents', to: `/benefits/${benefit}/documents` }] : []),
    ];
  }
}
